module.exports = __webpack_public_path__ + "img/532m_Hero.732b2af2.jpg";